import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { ActivityType } from './enum/activities.enum';

export const operationNotify = async (activityName: ActivityType): Promise<void> => {
  const requestBody = { activityName };
  const axiosConfig: AxiosRequestConfig = {
    url: `/transaction-management/transactions/operationNotify`,
    method: 'POST',
    data: requestBody,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  await emeraldRequest(emeraldRequestParams);
};
